import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import './model-video.css';

const VideoModel = ({ trailerId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div>
        <ModalVideo
          className="modal-video"
          channel="youtube"
          isOpen={isOpen}
          videoId={trailerId}
          onClose={closeModal}
        />
        <img
          className="video-thumbnail"
          onClick={openModal}
          src="https://corinthcapital.gr/wp-content/themes/theme/assets/files/img/icon/play-icon.png"
          alt="Video thumbnail"
        />
      </div>
    </>
  );
};

export default VideoModel;
